import { typography } from "../typography/typography.js";
import "../typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../typography/utils/typographyVariants/typographyVariants.js";
const MuiFormHelperText = {
  styleOverrides: {
    root: ({ theme }) => ({
      margin: "4px 16px 0",
      ...typography["Lato Caption"],
      color: theme.palette.grey[700],
      "&.Mui-error": {
        color: theme.palette.error[800]
      },
      "&.Mui-disabled": {
        color: theme.palette.grey[700]
      }
    })
  }
};
export {
  MuiFormHelperText
};
